var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSave = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 521 513.72",
  width: 521,
  height: 513.72,
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_BhuPF0JkJmSu6avkjV07pEDo08Uxq9pl"
}, /*#__PURE__*/React.createElement("rect", {
  width: 521,
  height: 513.72
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_BhuPF0JkJmSu6avkjV07pEDo08Uxq9pl)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 417.6 260.22 L 417.6 253.02 L 417.6 55.02 C 417.6 44.72 414.3 36.12 404.8 31.52 C 400.7 29.52 395.6 28.62 390.9 28.62 C 322.4 28.42 253.9 28.52 185.4 28.52 L 55.4 28.52 C 38.4 28.52 28.7 38.22 28.7 55.02 C 28.7 199.32 28.8 243.62 28.6 387.92 C 28.6 403.72 39 414.82 55.8 414.72 C 125.5 414.42 235.1 414.62 304.8 414.62 L 311.5 414.62 L 311.5 442.92 L 306.3 442.92 L 53.8 442.92 C 26.6 442.92 21.454 439.454 11.2 428.52 C 1.333 417.998 0 401.72 0 386.72 C 0.1 278.12 0.1 269.42 0.1 160.82 C 0.1 125.52 -0.1 90.12 0.2 54.82 C 0.4 24.02 8.127 18.123 21.7 7.22 C 30.808 -0.096 44 -0.08 56 0.02 C 124.3 0.12 192.6 0.02 261 0.02 L 392.5 0.02 C 418.8 0.12 423.905 2.466 434.2 12.72 C 443.963 22.445 446.4 37.92 446.4 52.22 C 446.5 140.02 446.5 167.82 446.5 255.72 C 446.5 257.82 446.9 260.22 443.5 260.22 L 417.6 260.22 Z ",
  fill: "rgb(0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 165.3 174.32 C 133.3 165.22 123.6 139.02 126.6 118.42 C 129.9 96.02 148.9 78.62 171 77.42 C 195.8 76.12 215.4 90.32 221.9 114.82 C 225.6 128.42 222.4 141.02 215 152.52 C 207.7 163.82 197 170.82 183.9 174.52 C 188.7 175.52 193.6 176.32 198.4 177.52 C 239.4 187.92 268.9 223.62 271.6 265.92 C 271.9 270.12 271.1 271.82 266.4 271.82 C 205.1 271.72 143.8 271.72 82.5 271.72 C 81 271.72 79.6 271.52 77.3 271.42 C 77.7 246.22 86.1 224.52 102.9 206.12 C 119.7 187.82 140.7 177.52 165.3 174.32 L 165.3 174.32 Z ",
  fill: "rgb(0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 433.4 513.72 L 342.1 414.72 L 417.5 414.72 L 417.5 309.32 L 446.1 309.32 L 446.1 414.42 L 521 414.42 L 433.4 513.72 Z ",
  fill: "rgb(0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 77.5 355.62 C 77.5 340.12 77.5 345.02 77.6 329.92 C 77.6 329.12 79 327.82 79.9 327.52 C 81.3 327.12 82.9 327.32 84.4 327.32 L 362.3 327.32 C 369.2 327.32 369.2 327.32 369.2 334.02 L 369.2 350.02 L 369.2 355.62 L 77.5 355.62 Z ",
  fill: "rgb(0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 320.6 126.32 L 368.7 126.32 L 368.7 154.52 L 330.1 154.52 C 320.6 154.52 320.6 154.52 320.6 145.02 L 320.6 126.32 Z ",
  fill: "rgb(0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 320.6 223.42 L 369.1 223.42 L 369.1 239.12 L 369.1 247.62 C 369.1 250.12 368.7 251.72 365.6 251.72 C 351.8 251.62 337.9 251.72 324.1 251.52 C 322.9 251.52 320.8 249.62 320.8 248.52 C 320.6 233.72 320.6 238.92 320.6 223.42 Z ",
  fill: "rgb(0,0,0)"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/save.fc0d11d4bbafe68cc7c196ccedbfc4bc.svg";